<template>
  <div class="menu-wrapper">
    <template v-for="item in routes" v-if="!item.hidden&&item.children">

      <router-link v-if="hasOneShowingChildren(item,item.children) && !item.children[0].children&&!item.alwaysShow"
                   :to="item.path+'/'+item.children[0].path"
                   :key="item.children[0].name">
        <el-menu-item :index="item.path+'/'+item.children[0].path" :class="{'submenu-title-noDropdown':!isNest}">
          <svg-icon v-if="item.children[0].meta&&item.children[0].meta.icon"
                    :icon-class="item.children[0].meta.icon"></svg-icon>
          <span v-if="item.children[0].meta&&item.children[0].meta.title"
                slot="title">{{ item.children[0].meta.title }}</span>
        </el-menu-item>
      </router-link>

      <el-submenu v-else :index="item.name||item.path" :key="item.name">
        <template slot="title">
          <svg-icon v-if="item.meta&&item.meta.icon" :icon-class="item.meta.icon"></svg-icon>
          <span v-if="item.meta&&item.meta.title" slot="title">{{ item.meta.title }}</span>
        </template>

        <template v-for="child in item.children" v-if="!child.hidden">
          <router-link
            v-if="hasOneShowingThreeChildren(child.children,item) && !child.children[0].children&&!child.alwaysShow"
            :to="child.path+'/'+child.children[0].path"
            :key="child.children[0].name">
            <el-menu-item :index="child.path+'/'+child.children[0].path" :class="{'submenu-title-noDropdown':!isNest}">
              <svg-icon v-if="child.children[0].meta&&child.children[0].meta.icon"
                        :icon-class="child.children[0].meta.icon"></svg-icon>
              <span v-if="child.children[0].meta&&child.children[0].meta.title"
                    slot="title">{{ child.children[0].meta.title }}</span>
            </el-menu-item>
          </router-link>
          <!--&lt;!&ndash;          <el-submenu v-else :index="child.name||child.path" :key="child.name">&ndash;&gt;-->
          <!--&lt;!&ndash;            <template slot="title">&ndash;&gt;-->
          <!--&lt;!&ndash;              <svg-icon v-if="child.meta&&child.meta.icon" :icon-class="child.meta.icon"></svg-icon>&ndash;&gt;-->
          <!--&lt;!&ndash;              <span v-if="child.meta&&child.meta.title" slot="title">{{child.meta.title}}</span>&ndash;&gt;-->
          <!--&lt;!&ndash;            </template>&ndash;&gt;-->
          <!--&lt;!&ndash;          </el-submenu>&ndash;&gt;-->
          <sidebar-item :is-nest="true" class="nest-menu" v-if="child.children&&child.children.length>0&&!item.hidden"
                        :routes="[child]" :key="child.path" ></sidebar-item>

          <router-link v-else :to="item.path+'/'+child.path" :key="child.name">
            <el-menu-item :index="item.path+'/'+child.path" style="padding-left: 47px">
              <svg-icon v-if="child.meta&&child.meta.icon" :icon-class="child.meta.icon"></svg-icon>
              <span v-if="child.meta&&child.meta.title" slot="title" :title="child.meta.title">{{ child.meta.title | titleFilter}}</span>
            </el-menu-item>
          </router-link>
        </template>
      </el-submenu>

    </template>
  </div>
</template>
<!--<template>-->
<!--  <div class="menu-wrapper">-->
<!--    <template v-for="item in routes" v-if="!item.hidden&&item.children">-->

<!--      <router-link v-if="hasOneShowingChildren(item.children) && !item.children[0].children&&!item.alwaysShow" :to="item.path+'/'+item.children[0].path"-->
<!--        :key="item.children[0].name">-->
<!--        <el-menu-item :index="item.path+'/'+item.children[0].path" :class="{'submenu-title-noDropdown':!isNest}">-->
<!--          <svg-icon v-if="item.children[0].meta&&item.children[0].meta.icon" :icon-class="item.children[0].meta.icon"></svg-icon>-->
<!--          <span v-if="item.children[0].meta&&item.children[0].meta.title" slot="title">{{item.children[0].meta.title}}</span>-->
<!--        </el-menu-item>-->
<!--      </router-link>-->

<!--      <el-submenu v-else :index="item.name||item.path" :key="item.name">-->
<!--        <template slot="title">-->
<!--          <svg-icon v-if="item.meta&&item.meta.icon" :icon-class="item.meta.icon"></svg-icon>-->
<!--          <span v-if="item.meta&&item.meta.title" slot="title">{{item.meta.title}}</span>-->
<!--        </template>-->

<!--        <template v-for="child in item.children" v-if="!child.hidden">-->
<!--          <sidebar-item :is-nest="true" class="nest-menu" v-if="child.children&&child.children.length>0" :routes="[child]" :key="child.path"></sidebar-item>-->

<!--          <router-link v-else :to="item.path+'/'+child.path" :key="child.name">-->
<!--            <el-menu-item :index="item.path+'/'+child.path">-->
<!--              <svg-icon v-if="child.meta&&child.meta.icon" :icon-class="child.meta.icon"></svg-icon>-->
<!--              <span v-if="child.meta&&child.meta.title" slot="title">{{child.meta.title}}</span>-->
<!--            </el-menu-item>-->
<!--          </router-link>-->
<!--        </template>-->
<!--      </el-submenu>-->

<!--    </template>-->
<!--  </div>-->
<!--</template>-->

<script>
export default {
  name: 'SidebarItem',
  filters: {
    titleFilter(value) {
      if (value.length > 10) {
        return value.substring(0, 10) + '...';
      }
      return value
    },
  },
  props: {
    routes: {
      type: Array
    },
    isNest: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    hasOneShowingChildren(item,children) {
      if (!children) {
        return false
      }
      const showingChildren = children.filter(item => {
        return !item.hidden
      })

      if (showingChildren.length === 1 && showingChildren[0].name === 'home') {
        return true
      }
      return false
    },
    hasOneShowingThreeChildren(children, item) {
      if (!children) {
        return false
      }
      const showingChildren = children.filter(item => {
        return !item.hidden
      })

      if (showingChildren.length === 1 && showingChildren[0].name === 'home') {
        return true
      }
      return false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue